import { render } from "./hot.vue?vue&type=template&id=d7972938&scoped=true"
import script from "./hot.vue?vue&type=script&lang=js"
export * from "./hot.vue?vue&type=script&lang=js"

import "./hot.vue?vue&type=style&index=0&id=d7972938&lang=scss&scoped=true"

import exportComponent from "/Users/bill/rongge/code/已售项目/20340305/front/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7972938"]])

export default __exports__